// Defaults to locked when the backend hasn't sent isLocked yet (undefined),
// for backward compatibility - a case is only treated as unlocked once the
// backend explicitly says so.
export default function isCaseLocked(data) {
  return data?.isLocked !== false;
}
